import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { API } from "../constants/config";

const GD = "#064E3B";
const GOLD = "#D4AF37";

const OFFERING_LABELS = {
  bank:      { icon: "🏦", label: "银行转账" },
  paypal:    { icon: "💳", label: "PayPal" },
  wechat:    { icon: "💚", label: "微信支付" },
  etransfer: { icon: "📧", label: "E-Transfer" },
  notes:     { icon: "📝", label: "备注" },
};

export default function TempleDetailPage({ setPage, lang }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [temple, setTemple] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [copied, setCopied] = useState("");

  useEffect(() => {
    fetch(`${API}/vajra/temples/${id}`)
      .then(r => { if (!r.ok) { setNotFound(true); setLoading(false); return null; } return r.json(); })
      .then(d => { if (d) { setTemple(d); setLoading(false); } })
      .catch(() => { setNotFound(true); setLoading(false); });
  }, [id]);

  const copy = (text, key) => {
    navigator.clipboard?.writeText(text).then(() => { setCopied(key); setTimeout(() => setCopied(""), 2000); });
  };

  if (loading) return <div style={{ textAlign: "center", paddingTop: 100, color: "#9ca3af" }}>加载中…</div>;
  if (notFound || !temple) return (
    <div style={{ textAlign: "center", paddingTop: 100 }}>
      <div style={{ fontSize: 28, marginBottom: 8 }}>☸</div>
      <div style={{ color: "#6b7280" }}>寺院不存在或已下线</div>
      <button onClick={() => navigate("/vajra/temples")} style={{ marginTop: 16, padding: "7px 18px", borderRadius: 7, border: `1px solid ${GD}`, background: "transparent", color: GD, cursor: "pointer" }}>寺院名录</button>
    </div>
  );

  const offering = temple.offering_info || {};

  return (
    <div style={{ maxWidth: 760, margin: "0 auto", padding: "0 16px 60px" }}>
      {/* Hero image */}
      {temple.photo_url
        ? <div style={{ width: "100%", maxHeight: 300, overflow: "hidden", borderRadius: "0 0 14px 14px" }}>
            <img src={temple.photo_url} alt={temple.name_zh} style={{ width: "100%", objectFit: "cover" }} />
          </div>
        : <div style={{ height: 120, background: "linear-gradient(135deg,#064E3B,#10b981)", borderRadius: "0 0 14px 14px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 36, opacity: 0.5 }}>☸</div>}

      <div style={{ padding: "24px 0 0" }}>
        <div style={{display:"flex",gap:16,alignItems:"center",marginBottom:14}}>
          <Link to="/vajra" style={{fontSize:12,color:"#8B6914",textDecoration:"none"}}>如意宝金刚社群</Link>
          <button onClick={() => navigate("/vajra/temples")} style={{ fontSize: 12, color: "#6b7280", background: "none", border: "none", cursor: "pointer", padding: 0 }}>寺院名录</button>
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 700, color: "#1a1a1a", marginBottom: 4 }}>{temple.name_zh}</h1>
        {temple.name_en && <div style={{ fontSize: 13, color: "#9ca3af", marginBottom: 12 }}>{temple.name_en}</div>}

        {/* Badges */}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 18 }}>
          {temple.tradition && <Badge>{temple.tradition}</Badge>}
          {temple.lineage   && <Badge>{temple.lineage}</Badge>}
          {temple.location  && <span style={{ fontSize: 12, color: "#6b7280" }}>📍 {temple.location}</span>}
          {temple.website && <a href={temple.website} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: GD }}>🌐 官网</a>}
        </div>

        {/* 关联上师 */}
        {temple.primary_teacher && (
          <div style={{ marginBottom: 16, fontSize: 13, color: "#4a3a1e" }}>
            🪷 主要上师：<strong>{temple.primary_teacher.name_zh}</strong>
          </div>
        )}

        {/* Description */}
        {temple.description_zh && (
          <p style={{ fontSize: 14, lineHeight: 1.9, color: "#374151", marginBottom: 20 }}>{temple.description_zh}</p>
        )}

        {/* 供养方式 */}
        {Object.keys(offering).length > 0 && (
          <Section title="供养方式">
            <div style={{ display: "grid", gap: 10 }}>
              {Object.entries(offering).map(([key, val]) => {
                if (!val) return null;
                const { icon, label } = OFFERING_LABELS[key] || { icon: "💰", label: key };
                return (
                  <div key={key} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", background: "rgba(212,175,55,0.06)", border: "1px solid rgba(212,175,55,0.18)", borderRadius: 8 }}>
                    <div>
                      <span style={{ fontSize: 12, color: "#6b5c3e", marginRight: 6 }}>{icon} {label}</span>
                      <span style={{ fontSize: 13, fontWeight: 600, color: "#1a1a1a" }}>{val}</span>
                    </div>
                    {key !== "notes" && (
                      <button onClick={() => copy(val, key)}
                        style={{ fontSize: 11, padding: "3px 10px", borderRadius: 6, border: "1px solid rgba(6,78,59,0.2)", background: "transparent", color: GD, cursor: "pointer" }}>
                        {copied === key ? "已复制" : "复制"}
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          </Section>
        )}

        {/* 联系方式 */}
        {temple.contact_info && (
          <Section title="联系方式">
            <p style={{ fontSize: 13, color: "#4b5563", lineHeight: 1.8 }}>{temple.contact_info}</p>
          </Section>
        )}

        {/* 关联法讯 */}
        {temple.events && temple.events.length > 0 && (
          <Section title="近期法讯">
            {temple.events.map(ev => (
              <Link key={ev.id} to={`/events/${ev.slug}`} style={{ textDecoration: "none" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "9px 12px", borderRadius: 7, border: "1px solid rgba(6,78,59,0.1)", marginBottom: 6, background: "#fff" }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1a1a" }}>{lang === 'en' && ev.title_en ? ev.title_en : ev.title_zh}</div>
                  <div style={{ fontSize: 11, color: "#9ca3af" }}>{ev.start_date || ""}</div>
                </div>
              </Link>
            ))}
          </Section>
        )}
      </div>
    </div>
  );
}

function Badge({ children }) {
  return <span style={{ fontSize: 11, padding: "2px 9px", borderRadius: 10, background: "rgba(6,78,59,0.08)", color: GD }}>{children}</span>;
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: GD, marginBottom: 10, borderBottom: "1px solid rgba(6,78,59,0.1)", paddingBottom: 6 }}>{title}</div>
      {children}
    </div>
  );
}
